import React from 'react'

const PlayButton = ({attr}) => { 
  return (
    <a className="play-btn" {...attr}> 
        <svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="49" cy="49" r="49" fill="black"/>
            <path d="M67 49L40 64.5885L40 33.4115L67 49Z" fill="#FFFFF0"/>
        </svg>
    </a>
  )
}

export default PlayButton